import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSelectionListChange} from "@angular/material/list";
import {MethodModel} from "@app/pages/tickets/hra/hra.component";

@Component({
  selector: 'flex-security-images',
  templateUrl: './security-images.component.html',
  styleUrls: ['./security-images.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecurityImagesComponent implements OnInit {
  selectedImages: string[] = [];
  securityImageList: string[] = [
    '../../../../images/captchaImg/002.jpg', '../../../../images/captchaImg/100.jpg', '../../../../images/captchaImg/101.jpg',
    '../../../../images/captchaImg/102.jpg', '../../../../images/captchaImg/103.jpg', '../../../../images/captchaImg/104.jpg',
    '../../../../images/captchaImg/105.jpg', '../../../../images/captchaImg/106.jpg', '../../../../images/captchaImg/107.jpg',
    '../../../../images/captchaImg/108.jpg', '../../../../images/captchaImg/109.jpg', '../../../../images/captchaImg/110.jpg',
    '../../../../images/captchaImg/111.jpg', '../../../../images/captchaImg/112.jpg', '../../../../images/captchaImg/113.jpg',
    '../../../../images/captchaImg/114.jpg', '../../../../images/captchaImg/115.jpg', '../../../../images/captchaImg/116.jpg',
    '../../../../images/captchaImg/117.jpg', '../../../../images/captchaImg/118.jpg', '../../../../images/captchaImg/119.jpg',
    '../../../../images/captchaImg/120.jpg', '../../../../images/captchaImg/121.jpg', '../../../../images/captchaImg/122.jpg',
    '../../../../images/captchaImg/123.jpg', '../../../../images/captchaImg/124.jpg', '../../../../images/captchaImg/125.jpg',
    '../../../../images/captchaImg/126.jpg', '../../../../images/captchaImg/127.jpg', '../../../../images/captchaImg/128.jpg',
    '../../../../images/captchaImg/129.jpg', '../../../../images/captchaImg/130.jpg', '../../../../images/captchaImg/131.jpg',
    '../../../../images/captchaImg/132.jpg', '../../../../images/captchaImg/133.jpg', '../../../../images/captchaImg/134.jpg',
    '../../../../images/captchaImg/135.jpg', '../../../../images/captchaImg/136.jpg', '../../../../images/captchaImg/137.jpg',
    '../../../../images/captchaImg/138.jpg', '../../../../images/captchaImg/139.jpg', '../../../../images/captchaImg/140.jpg',
    '../../../../images/captchaImg/141.jpg', '../../../../images/captchaImg/142.jpg', '../../../../images/captchaImg/143.jpg',
    '../../../../images/captchaImg/144.jpg', '../../../../images/captchaImg/145.jpg', '../../../../images/captchaImg/146.jpg',
    '../../../../images/captchaImg/147.jpg', '../../../../images/captchaImg/148.jpg', '../../../../images/captchaImg/149.jpg',
    '../../../../images/captchaImg/150.jpg', '../../../../images/captchaImg/151.jpg', '../../../../images/captchaImg/152.jpg',
    '../../../../images/captchaImg/153.jpg', '../../../../images/captchaImg/154.jpg', '../../../../images/captchaImg/155.jpg',
    '../../../../images/captchaImg/156.jpg', '../../../../images/captchaImg/157.jpg', '../../../../images/captchaImg/158.jpg',
    '../../../../images/captchaImg/159.jpg', '../../../../images/captchaImg/160.jpg', '../../../../images/captchaImg/161.jpg',
    '../../../../images/captchaImg/162.jpg', '../../../../images/captchaImg/163.jpg', '../../../../images/captchaImg/164.jpg',
    '../../../../images/captchaImg/165.jpg', '../../../../images/captchaImg/166.jpg', '../../../../images/captchaImg/167.jpg',
    '../../../../images/captchaImg/168.jpg', '../../../../images/captchaImg/169.jpg', '../../../../images/captchaImg/170.jpg',
    '../../../../images/captchaImg/171.jpg', '../../../../images/captchaImg/172.jpg', '../../../../images/captchaImg/173.jpg',
    '../../../../images/captchaImg/174.jpg', '../../../../images/captchaImg/175.jpg', '../../../../images/captchaImg/176.jpg',
    '../../../../images/captchaImg/177.jpg', '../../../../images/captchaImg/178.jpg', '../../../../images/captchaImg/179.jpg',
    '../../../../images/captchaImg/180.jpg', '../../../../images/captchaImg/181.jpg', '../../../../images/captchaImg/182.jpg',
    '../../../../images/captchaImg/183.jpg', '../../../../images/captchaImg/184.jpg', '../../../../images/captchaImg/185.jpg',
    '../../../../images/captchaImg/186.jpg', '../../../../images/captchaImg/187.jpg', '../../../../images/captchaImg/188.jpg',
    '../../../../images/captchaImg/189.jpg', '../../../../images/captchaImg/190.jpg', '../../../../images/captchaImg/191.jpg',
    '../../../../images/captchaImg/192.jpg', '../../../../images/captchaImg/193.jpg', '../../../../images/captchaImg/194.jpg',
    '../../../../images/captchaImg/195.jpg', '../../../../images/captchaImg/196.jpg', '../../../../images/captchaImg/197.jpg',
    '../../../../images/captchaImg/198.jpg', '../../../../images/captchaImg/199.jpg', '../../../../images/captchaImg/200.jpg',
    '../../../../images/captchaImg/201.jpg', '../../../../images/captchaImg/202.jpg', '../../../../images/captchaImg/203.jpg',
    '../../../../images/captchaImg/204.jpg', '../../../../images/captchaImg/205.jpg', '../../../../images/captchaImg/206.jpg',
    '../../../../images/captchaImg/207.jpg', '../../../../images/captchaImg/208.jpg', '../../../../images/captchaImg/209.jpg',
    '../../../../images/captchaImg/210.jpg', '../../../../images/captchaImg/211.jpg', '../../../../images/captchaImg/212.jpg',
    '../../../../images/captchaImg/213.jpg', '../../../../images/captchaImg/214.jpg', '../../../../images/captchaImg/215.jpg',
  ];

  constructor(public dialogRef: MatDialogRef<SecurityImagesComponent>,
      @Inject(MAT_DIALOG_DATA) public data: {method: MethodModel, listOption: number}) {}

  ngOnInit(): void {
  }
  onNoClick() {

    this.dialogRef.close();
  }
  addSelection(event: MatSelectionListChange) {
    let tempList: string[] = [];
    event.source._value.forEach(img => {
      let tempImage = img.substr((img.length - 7))
      tempList.push(tempImage)
    })
    if (this.data.listOption === 0) {
      this.data.method.displayImageList = tempList;
    } else {
      this.data.method.selectImageList = tempList;
    }
  }
  isSelected(fileName: string) {
    return this.selectedImages.includes(fileName);
  }
  changeSelection(fileName: string) {
    if(this.selectedImages.includes(fileName)) {
      let index = this.selectedImages.indexOf(fileName);
      this.selectedImages.splice(index, 1);
    } else {
      this.selectedImages.push(fileName);
    }
  }
}
export class SecurityImage {
  name: string
  location: string;
}
